export const PASSWORD_POLICY_I18N_KEYS = Object.freeze({
  minimum_length: 'auth.password_policy.minimum_length',
  maximum_length: 'auth.password_policy.maximum_length',
  minimum_digits: 'auth.password_policy.minimum_digits',
  minimum_lowercase: 'auth.password_policy.minimum_lowercase',
  minimum_uppercase: 'auth.password_policy.minimum_uppercase',
  minimum_special_characters: 'auth.password_policy.minimum_special_characters',
  not_email: 'auth.password_policy.not_email'
})

const countCharacters = (password, predicate) => Array.from(password).filter(predicate).length

const countDigits = password => countCharacters(password, character => /[0-9]/.test(character))
const countLowercase = password => countCharacters(password, character => /[a-z]/.test(character))
const countUppercase = password => countCharacters(password, character => /[A-Z]/.test(character))
const isSpecialCharacter = character => /[^a-zA-Z0-9]/.test(character)
const countSpecialCharacters = password => countCharacters(password, isSpecialCharacter)
const DISPLAY_RULES = [
  'minimum_length',
  'maximum_length',
  'minimum_digits',
  'minimum_lowercase',
  'minimum_uppercase',
  'minimum_special_characters'
]

export const requiresServerValidation = policy => policy?.available !== true ||
  policy.server_validation_required === true ||
  policy.unsupported_rules?.length > 0

export const passwordPolicyDisplayRules = policy => {
  if (policy?.available !== true) return []

  const rules = DISPLAY_RULES.filter(rule => {
    const value = policy[rule]

    return rule === 'maximum_length' ? value != null : value > 0
  }).map(rule => ({
    key: PASSWORD_POLICY_I18N_KEYS[rule],
    value: policy[rule]
  }))

  return policy.not_email ? rules.concat({key: PASSWORD_POLICY_I18N_KEYS.not_email}) : rules
}

export default function evaluatePasswordPolicy({policy, password, email}) {
  if (policy?.available !== true) {
    return {
      violations: [],
      requiresServerValidation: true
    }
  }

  const value = typeof password === 'string' ? password : ''
  const emailValue = typeof email === 'string' ? email : ''
  const violations = []
  const passwordLength = Array.from(value).length

  if (passwordLength < policy.minimum_length) violations.push('minimum_length')
  if (policy.maximum_length != null && passwordLength > policy.maximum_length) {
    violations.push('maximum_length')
  }
  if (countDigits(value) < policy.minimum_digits) violations.push('minimum_digits')
  if (countLowercase(value) < policy.minimum_lowercase) violations.push('minimum_lowercase')
  if (countUppercase(value) < policy.minimum_uppercase) violations.push('minimum_uppercase')
  if (countSpecialCharacters(value) < policy.minimum_special_characters) {
    violations.push('minimum_special_characters')
  }
  if (policy.not_email && value.toLowerCase() === emailValue.toLowerCase()) {
    violations.push('not_email')
  }

  return {
    violations,
    requiresServerValidation: requiresServerValidation(policy)
  }
}
